import useBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink } from "react-router-dom";
import { useLayout } from "../../../../provider/LayoutProvider";
import { Breadcrumb } from "./styles";

const routes = [
  {
    path: "dashboard", // Add a leading slash to the parent path
    breadcrumb: null,
    children: [
      {
        path: "cursos", // Add a leading slash to the child path
        breadcrumb: "Cursos",
        children: [
          { path: "new", breadcrumb: "Nuevo Curso" },
          { path: "list", breadcrumb: "Todos los cursos" },
          { path: "edit", breadcrumb: "Editar Curso" },
          { path: "preview", breadcrumb: "Curso" },
        ],
      },
      {
        path: "mis-cursos", // Add a leading slash to the child path
        breadcrumb: "Mis Cursos",
        children: [{ path: "list", breadcrumb: "Mis Cursos" }],
      },
      {
        path: "mi-perfil", // Add a leading slash to the child path
        breadcrumb: "Mi Perfil",
        children: [{ index: true, breadcrumb: "Mi Perfil" }],
      },
    ],
  },
];

const Component = () => {
  const { layout } = useLayout();
  const breadcrumbs = useBreadcrumbs(routes);

  if (!layout.showBreadcrumb) {
    return null;
  }

  return (
    <Breadcrumb>
      <ol>
        {breadcrumbs.map(({ match, breadcrumb }) => (
          <li key={match.pathname}>
            <NavLink to={match.pathname === '/' ? '/dashboard' : match.pathname}>{breadcrumb}</NavLink>
          </li>
        ))}
      </ol>
    </Breadcrumb>
  );
};

export default Component;
